import React from 'react';
import {Transition} from 'react-transition-group';
import {headerSubmenuDuration, cubicEasing} from '../config/animation';
import Flickity from './Flickity';
import classNames from 'classnames';
import imageAspectRatioStyles from '../utils/imageAspectRatioStyles';

const UNDERLAY_DEFAULT_STYLE = {
	transition: `opacity ${headerSubmenuDuration}ms ease-in-out`,
	opacity: 0,
};

const UNDERLAY_TRANSITION_STYLES = {
	entering: {opacity: 0},
	entered: {opacity: 1},
};

const CAROUSEL_DEFAULT_STYLE = {
	transition: `opacity ${headerSubmenuDuration}ms ease-in-out, transform 400ms cubic-bezier(0, 0, 0.25, 1)`,
	opacity: 0,
};

const CAROUSEL_TRANSITION_STYLES = {
	entering: {
		opacity: 0,
		transform: 'scale(0.95)',
	},
	entered: {opacity: 1},
};

const BUTTON_DEFAULT_STYLE = {
	transition: `opacity ${headerSubmenuDuration}ms ease-in-out`,
	opacity: 0,
};

const BUTTON_TRANSITION_STYLES = {
	entering: {
		opacity: 0
	},
	entered: {
		transition: `opacity ${headerSubmenuDuration}ms ease-in-out ${headerSubmenuDuration}ms, transform ${headerSubmenuDuration}ms ${cubicEasing}`,
		opacity: 1
	},
};

const SLIDE_OPTIONS = {
	cellAlign: 'center',
	contain: true,
	wrapAround: true,
	pageDots: false,
	prevNextButtons: false,
	selectedAttraction: 0.1,
	friction: 0.8
};

export default ({
	initialIndex = 0,
	active = false,
	preserveImageAspectRatio = false,
	assets = [],
	onClose,
	onNext,
	onPrevious,
	onChange,
	sliderRef,
}) => {
	return (
	<React.Fragment>
		<Transition
			in={Boolean(active)}
			mountOnEnter
			unmountOnExit
			appear
			timeout={{
				enter: 0,
				exit: headerSubmenuDuration,
			}}>{state => (
			<div
				className="product__hero-underlay"
				style={{
					...UNDERLAY_DEFAULT_STYLE,
					...UNDERLAY_TRANSITION_STYLES[state]
				}}
			/>
		)}</Transition>
		<Transition
			in={Boolean(active)}
			mountOnEnter
			unmountOnExit
			appear
			timeout={headerSubmenuDuration}>{state => (
			<div
				className="product__hero-modal-carousel multiply"
				style={{
					...CAROUSEL_DEFAULT_STYLE,
					...CAROUSEL_TRANSITION_STYLES[state]
				}}>
				<Flickity
					sliderRef={sliderRef}
					className="multiply"
					options={{
						...SLIDE_OPTIONS,
						initialIndex,
						on: {
							change: index => onChange(index)
						},
					}}>
					{assets.map(asset => {
						let carouselAsset;

						if (asset && asset._type === 'image') {
							carouselAsset = (
								<div
									style={preserveImageAspectRatio ? imageAspectRatioStyles(asset.dimensions.aspectRatio) : null}
									className={classNames('image', {
										'size--1x1': !preserveImageAspectRatio
									})}>
									<picture>
										<img
											src={`${asset.url}?w=1000&auto=format`}
											alt={asset.alt}
										/>
									</picture>
								</div>
							);
						} else if (asset && asset._type === 'video') {
							const __html = (`
								<video
									class="full-width"
									muted
									autoplay
									playsinline
									preload
									loop
									poster="${asset.posterImage}?w=1000&auto=format">
									<source
										src="${asset.url}"
										type="video/mp4"
									></source>
								</video>
							`);

							carouselAsset = (
								<div
									className="full-width"
									dangerouslySetInnerHTML={{__html}}
								/>
							);
						}

						return (
							<div
								key={asset._key}
								className="full-width">
								<div
									className="product__hero-modal-asset-container vertical-align-container m--auto"
									style={preserveImageAspectRatio ? {
										width: `${100 * asset.dimensions.aspectRatio}vh`
									} : null}>
									<div className="full-width">
										{carouselAsset}
									</div>
								</div>
							</div>
						);
					})}
				</Flickity>
			</div>
		)}</Transition>
		<Transition
			in={Boolean(active)}
			mountOnEnter
			unmountOnExit
			appear
			timeout={{
				enter: 0,
				exit: headerSubmenuDuration,
			}}>{state => (
			<React.Fragment>
				<button
					className="db product__hero-modal-close"
					title="close"
					name="close"
					onClick={onClose}
					style={{
						...BUTTON_DEFAULT_STYLE,
						...BUTTON_TRANSITION_STYLES[state]
					}}>
					<img
						alt="close"
						className="db"
						src="/images/icon-pdp-hero-close.svg"
					/>
				</button>
				<button
					className="db product__hero-modal-next"
					title="next"
					name="next"
					onClick={onNext}
					style={{
						...BUTTON_DEFAULT_STYLE,
						...BUTTON_TRANSITION_STYLES[state]
					}}>
					<img
						alt="next"
						className="db p2"
						src="/images/icon-carousel-next.svg"
					/>
				</button>
				<button
					className="db product__hero-modal-previous"
					title="previous"
					name="previous"
					onClick={onPrevious}
					style={{
						...BUTTON_DEFAULT_STYLE,
						...BUTTON_TRANSITION_STYLES[state]
					}}>
					<img
						alt="previous"
						className="db flip p2"
						src="/images/icon-carousel-next.svg"
					/>
				</button>
			</React.Fragment>
		)}</Transition>
	</React.Fragment>
)};